import React, { useEffect, useState } from "react";
import { ProductCategoryType } from "../../types";

type CategoryProps = {
  category: ProductCategoryType;
  className: string;
};
const Category = ({ category, className }: CategoryProps) => {
  let [color, setColor] = useState("bg-sky-400");

  useEffect(() => {
    switch (category) {
      case "Outdoor":
        setColor("bg-emerald-400");
        break;
      case "Transportasi":
        setColor("bg-blue-400");
        break;
      case "Keperluan Anak":
        setColor("bg-purple-400");
        break;
      default:
        break;
    }
  }, [category]);

  return (
    <div
      className={`py-1 px-2 rounded-md w-fit text-white ${color} ${className}`}
    >
      {category}
    </div>
  );
};

Category.defaultProps = { category: "Transportation", className: "" };

export default Category;
